export const env = new Proxy({
    _: {},
    setup(_) {
        this._ = _;
    },
}, {
    get(target, p) {
        return target._[p] || target[p];
    },
});
//# sourceMappingURL=Env.js.map